import { render, staticRenderFns } from "./trilha-form.vue?vue&type=template&id=212bedee"
import script from "./trilha-form.vue?vue&type=script&lang=js"
export * from "./trilha-form.vue?vue&type=script&lang=js"
import style0 from "./trilha-form.vue?vue&type=style&index=0&id=212bedee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports